module.exports = __webpack_public_path__ + "static/media/cairo-bold.ff0dbc43.woff";